const referralSettings = {
  apiClient: null,
  path: '/admin/referral-settings',

  setClient(apiClient) {
    this.apiClient = apiClient;
  },

  async get() {
    const response = await this.apiClient.get(this.path);
    return response.data;
  },

  async update(form) {
    const response = await this.apiClient.put(this.path, form);
    return response.data;
  },
};

export default referralSettings;
